<div class="site">
  <div class="overall-body-style">
    <mas-retail-shell>
    </mas-retail-shell>
  </div>
</div>
